import { render } from "./Directors.vue?vue&type=template&id=15fa0e66&scoped=true&ts=true"
import script from "./Directors.vue?vue&type=script&lang=ts"
export * from "./Directors.vue?vue&type=script&lang=ts"

import "./Directors.vue?vue&type=style&index=0&id=15fa0e66&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fa0e66"]])

export default __exports__